import { loginByUsername, logout, getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    userId: null, // 用户id
    orgId: null, // 机构id
    userType: null, // 用户类型
    orgType: null, // 机构类型
    orgName: null, // 机构名称
    token: getToken(),
    menus: [], // 菜单
    operationPerms: [], // 权限
    setting: {},
    profile: {},
    rangeList: {}
  },

  mutations: {
    SET_USERID: (state, userId) => {
      state.userId = userId
    },
    SET_ORGID: (state, orgId) => {
      state.orgId = orgId
    },
    SET_USER_TYPE: (state, userType) => {
      state.userType = userType
    },
    SET_ORG_TYPE: (state, orgType) => {
      state.orgType = orgType
    },
    SET_ORG_NAME: (state, orgName) => {
      state.orgName = orgName
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_SETTING: (state, setting) => {
      state.setting = setting
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_PROFILE: (state, profile) => {
      state.profile = profile
    },
    SET_MENUS: (state, menus) => {
      state.menus = menus
    },
    SET_OPERATION_PERMS: (state, operationPerms) => {
      state.operationPerms = operationPerms
    },
    SET_RANGELIST: (state, rangeList) => {
      state.rangeList = rangeList
    }
  },

  actions: {
    ChangeUserName({ commit }, userName) {
      commit('SET_NAME', userName)
    },
    // 用户名登录
    LoginByUsername({ commit }, userInfo) {
      // 用户名
      const username = userInfo.username.trim()
      // 机构标识
      const orgCode = userInfo.orgCode.trim()
      return new Promise((resolve, reject) => {
        loginByUsername(orgCode, username, userInfo.password).then(response => {
          if (response.data.success) {
            const data = response.data.result
            commit('SET_TOKEN', data.token)
            setToken(data.token)
            resolve()
          } else {
            reject()
          }
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 获取用户信息
    GetUserInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        getUserInfo().then(response => {
          if (!response.data) { // 由于mockjs 不支持自定义状态码只能这样hack
            reject('error')
          }
          const data = response.data.result
          if (data.menus && data.menus.length > 0) { // 验证返回的menus是否是一个非空数组
            commit('SET_MENUS', data.menus)
          } else {
            reject('此账号无任何菜单权限,禁止登录!')
          }
          // 在store中写入操作权限
          if (data.operationPerms && data.operationPerms.length > 0) {
            commit('SET_OPERATION_PERMS', data.operationPerms)
          }
          var rangeList = {}
          // data.rangeList.forEach((item, index) => {
          //   rangeList[item.zhName] = item
          // })
          commit('SET_NAME', data.name)
          commit('SET_USERID', data.sysUser.id)
          commit('SET_ORGID', data.sysUser.sysOrg.id)
          commit('SET_ORG_TYPE', data.sysUser.sysOrg.orgType)
          commit('SET_ORG_NAME', data.sysUser.sysOrg.orgName)
          commit('SET_USER_TYPE', data.sysUser.userType)
          commit('SET_PROFILE', data.profile)
          commit('SET_RANGELIST', rangeList)
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        // 移除token
        removeToken()
        logout(state.token).then(() => {
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js